import React from "react";
import styled from "styled-components";

export default styled.a`
    font-size: 18px;
    font-weight: 700;
    // margin-top: 20px;
    display: inline-block;
    cursor: pointer;
    width: 100%;
    margin-bottom: 25px;
    
    ${(props) =>
    props.hidden
        ? {
        "display": "none",
    }
        : ""}
`;